module.exports = __webpack_public_path__ + "static/media/finster.4ae889c1.mp3";